<template>
  <div class="shipping">
    <div class='tabs'>
      <div @click='typeFun(0)' class='left' :class='{ active: planType === 0 }'>车型发运量</div>
      <div @click='typeFun(1)' :class='{ active: planType === 1 }'>公路数据</div>
      <div @click='typeFun(2)' :class='{ active: planType === 2 }'>水路数据</div>
      <div @click='typeFun(3)' class='right' :class='{ active: planType === 3 }'>水路车型</div>
    </div>
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="作业时间:">
          <el-date-picker v-model="form.start" size="mini" style="width:150px"  value-format="yyyy-MM-dd"
            @change="dateChange" type="date" placeholder="开始日期" />
          <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
          <el-date-picker v-model="form.end" size="mini" style="width:150px" value-format="yyyy-MM-dd"
            @change="dateChange" type="date" placeholder="结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span @click="exportData" style="cursor:pointer;font-size: 16px;">导出数据</span>
        </div>
        <el-table v-loading="tableLoad" :data="tableData" style="width: 100%" border ref="tableRef"
          :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', 'height': '48px', background: '#E8E8E8' }"
          :cell-style="{ height: '42px', }">
          <el-table-column type="index" label="序号" align="center" width="50" />
          <el-table-column v-for="item in columns" :key="item.prop" :prop="item.prop" :label="item.label"
            :align="item.align" :min-width="item.width" show-overflow-tooltip />
        </el-table>
      </div>
      <div v-if="planType !== 0" class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
          :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange"
          :current-page.sync="form.page" :page-size="form.rows" />
      </div>
    </div>
  </div>
</template>

<script>
import { getShippingList } from '@/service/vehiclelog';
import { getSessionStore } from "@/config/mUtils";
import { baseUrl } from '@/config/env'

export default {
  data() {
    return {
      planType: 0,
      form: { start: '', end: '', page: 1, rows: 10 },
      total: 0,
      tableLoad: false,
      TableData: [],
      columns: [
        { prop: 'brand', label: '车型', align: 'center', width: 120 },
        { prop: 'number', label: '发运量', align: 'center', width: 120 },
        { prop: 'total', label: '发运总量', align: 'center', width: 120 }
      ],
    }
  },
  mounted() {
   // this._getPageList();
  },
  methods: {
    // 切换标签页
    typeFun(val) {
      this.planType = val;
      switch (val) {
        case 0:
          this.columns = [
            { prop: 'brand', label: '车型', align: 'center', width: 120 },
            { prop: 'number', label: '发运量', align: 'center', width: 120 },
            { prop: 'total', label: '发运总量', align: 'center', width: 120 }
          ];
          // this._getPageList();
          break;
        case 1:
          this.columns = [
            { prop: 'date', label: '发出日期', align: 'center', width: 120 },
            { prop: 'loadingSite', label: '装车地', align: 'center', width: 120 },
            { prop: 'unloadingSite', label: '卸车地', align: 'center', width: 120 },
            { prop: 'consignor', label: '托运单位', align: 'center', width: 120 },
            { prop: 'brand', label: '品牌', align: 'center', width: 120 },
            { prop: 'model', label: '型号', align: 'center', width: 120 },
            { prop: 'number', label: '底盘号', align: 'center', width: 120 },
            { prop: 'paymentUnit', label: '结费单位', align: 'center', width: 120 },
            { prop: 'volume', label: '运量', align: 'center', width: 120 },
            { prop: 'chassisQuantity', label: '底盘量', align: 'center', width: 120 },
            { prop: 'firstVolume', label: '首运量', align: 'center', width: 120 }
          ];
          // this._getPageList();
          break;
        case 2:
          this.columns = [
            { prop: 'transportVehicles', label: '运输工具', align: 'center', width: 120 },
            { prop: 'voyageNumber', label: '航次', align: 'center', width: 120 },
            { prop: 'course', label: '航向', align: 'center', width: 120 },
            { prop: 'date', label: '发出日期', align: 'center', width: 120 },
            { prop: 'loadingSite', label: '装车地', align: 'center', width: 120 },
            { prop: 'unloadingSite', label: '卸车地', align: 'center', width: 120 },
            { prop: 'consignor', label: '托运单位[主机厂]', align: 'center', width: 140 },
            { prop: 'brand', label: '车型', align: 'center', width: 120 },
            { prop: 'model', label: '车型系列', align: 'center', width: 120 },
            { prop: 'loadingSiteTask', label: '装车作业点', align: 'center', width: 120 },
            { prop: 'unloadingSiteTask', label: '卸车作业点', align: 'center', width: 120 },
            { prop: 'volume', label: '运量', align: 'center', width: 120 },
            { prop: 'chassisQuantity', label: '底盘号量', align: 'center', width: 120 },
            { prop: 'firstVolume', label: '首运量', align: 'center', width: 120 },
            { prop: 'boatFirstVolume', label: '船首运', align: 'center', width: 120 }
          ];
          // this._getPageList();
          break;
        case 3:
          this.columns = [
            { prop: 'transportVehicles', label: '运输工具', align: 'center', width: 120 },
            { prop: 'voyageNumber', label: '航次', align: 'center', width: 120 },
            { prop: 'course', label: '航向', align: 'center', width: 120 },
            { prop: 'date', label: '发出日期', align: 'center', width: 120 },
            { prop: 'loadingSite', label: '装车地', align: 'center', width: 120 },
            { prop: 'unloadingSite', label: '卸车地', align: 'center', width: 120 },
            { prop: 'consignor', label: '托运单位[主机厂]', align: 'center', width: 140 },
            { prop: 'brand', label: '车型', align: 'center', width: 120 },
            { prop: 'model', label: '车型系列', align: 'center', width: 120 },
            { prop: 'loadingSiteTask', label: '装车作业点', align: 'center', width: 120 },
            { prop: 'unloadingSiteTask', label: '卸车作业点', align: 'center', width: 120 },
            { prop: 'frame_number', label: '底盘号', align: 'center', width: 120 },
            { prop: 'volume', label: '运量', align: 'center', width: 120 },
            { prop: 'chassisQuantity', label: '底盘号量', align: 'center', width: 120 },
            { prop: 'firstVolume', label: '首运量', align: 'center', width: 120 },
            { prop: 'boatFirstVolume', label: '船首运', align: 'center', width: 120 }
          ];
          // this._getPageList();
          break;
        default:
          this.columns = [
            { prop: 'brand', label: '车型', align: 'center', width: 120 },
            { prop: 'number', label: '发运量', align: 'center', width: 120 },
            { prop: 'total', label: '发运总量', align: 'center', width: 120 }
          ];
          // this._getPageList();
      }
    },
    compareDate(d1, d2) {
      return ((new Date(d1.replace(/-/g, "\/"))) > (new Date(d2.replace(/-/g, "\/"))));
    },
    // 结束时间
    dateChange(val) {
      if (this.form.end && this.form.start && this.compareDate(this.form.start, this.form.end)) {
        if (val == this.form.end) this.form.end = '';
        if (val == this.form.start) this.form.start = '';
        this.$forceUpdate();
        return this.$message.warning("结束日期必须大于开始日期！");
      }
    },
    // 查询
    searchBtn() {
      this.form.page = 1;
      this._getPageList();
    },
    // 重置
    resetBtn() {
      for (const argumentsKey in this.form) { this.form[argumentsKey] = ""; }
      this.form.page = 1;
      this.form.rows = 10;
    },
    // 分页查询
    async _getPageList() {
      this.tableLoad = true;
      const obj = {
        startDate: this.form.start || '',
        endDate: this.form.end || '',
        statisticsType: this.planType
      };
      const { status, message, data } = await getShippingList(obj);
      this.tableLoad = false;
      if (status !== 0) return this.$message.warning(message);
      this.tableData = data.records;
      this.$forceUpdate();
      this.total = data.total;
    },
    contractSizeChange(row) {
      this.form.rows = row;
      this._getPageList();
    },
    contractCurrentChange(page) {
      this.form.page = page;
      this._getPageList();
    },
    // 导出
    exportData() {
      const obj = {
        start: this.form.start || '',
        end: this.form.end || '',
        type: this.planType
      };
      // let token = getSessionStore('token');
      // let url = `${baseUrl}/platform/vehicleDeployCar/export?access_token=${token}&startDate=${obj.start}&endDate=${obj.end}&statisticsType=${obj.type}`;
      // window.location.href = url;
      window.exportExcelGet('/platform/vehicleDeployCar/export', `startDate=${obj.start}&endDate=${obj.end}&statisticsType=${obj.type}`);
    }
  }
}
</script>

<style lang='scss' scoped>
.shipping {
  width: 100%;
  padding: 20px 15px 0 25px;
  height: calc(100% - 30px);
  overflow-y: auto;

  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 480px;
    margin-bottom: 20px;

    div {
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: #48599E;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599E;
      font-weight: 700;
      transition: all .3s;
    }

    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .right {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .active {
      background: #48599E;
      color: #fff;
    }
  }

  ::v-deep.nav {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;

    .flex1 {
      flex: 1;
    }

    .el-input {
      width: 150px;
    }

    .el-select {
      width: 150px;
    }

    .el-form-item {
      margin-bottom: 5px;
    }

    label.el-form-item__label {
      font-weight: 500;
      color: #101010;
    }
  }

  .tableContainer {
    margin-bottom: 25px;
    width: 100%;
  }

  .tableContainerNav {
    text-align: right;

    span {
      color: #3388ff;
      text-decoration: underline;
    }
  }
}
</style>
